import { Redirect, Router } from '@reach/router'
import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import ActivateQrcodePage from '../../modules/qrcodes/activate/ActivateQrcodePage'
import AssetListPage from '../../modules/assets/list/AssetListPage'
import AvailabilityPage from '../../modules/availability/list/AvailabilityPage'
import AuthTemplate from '../../components/templates/AuthTemplate'
import BioqualynetAcPage from '../../modules/pdfs/bioqualynet/ac/BioqualynetAcPage'
import BioqualynetAetPdfPage from '../../modules/pdfs/bioqualynet/aet/BioqualynetAetPdfPage'
import BioqualynetPgrPdfPage from '../../modules/pdfs/bioqualynet/pgr/BioqualynetPgrPdfPage'
import BioqualynetPgrTablePage from '../../modules/pdfs/bioqualynet/pgrTable/BioqualynetPgrTablePage'
import BradescoPgrPdfPage from '../../modules/pdfs/bradesco/pgr/BradescoPgrPdfPage'
import ChecklistsListPage from '../../modules/checklists/list/ChecklistsListPage'
import DashboardV2Page from '../../modules/dashboard/v2/DashboardV2Page'
import EditChecklistPage from '../../modules/checklists/edit/EditChecklistPage'
import EditQrCodeTemplatePage from '../../modules/buckets/pdf/EditQrCodeTemplatePage'
import EditSegmentPage from '../../modules/segments/edit/EditSegmentPage'
import EditServiceOrderPage from '../../modules/serviceOrders/editV2/EditServiceOrderPage'
import EditTemplateContentPage from '../../modules/templates/editContent/EditTemplateContentPage'
import EditUserPage from '../../modules/users/editV2/EditUserPage'
import FormExecutionPage from '../../modules/forms/execution/FormExecutionPage'
import FormRepliesPage from '../../modules/formReplies/list/FormRepliesPage'
import FormReplyPage from '../../modules/formReplies/show/FormReplyPage'
import FormReplyPdfPage from '../../modules/formReplies/pdf/FormReplyPdfPage'
import FormsListPage from '../../modules/forms/list/FormsListPage'
import FullMessagePage from '../../modules/messages/FullMessagePage'
import GroupsListPage from '../../modules/groups/list/GroupsListPage'
import HomePage from '../../modules/home/HomePage'
import ImportPageV2 from '../../modules/importsExports/importV2/ImportPageV2'
import LoggedProfilePage from '../../modules/profiles/show/LoggedProfilePage'
import LogsListPage from '../../modules/logs/list/LogsListPage'
import MAssetListPage from '../../modules/assets/list/m/M.AssetsListPage'
import MLoggedProfilePage from '../../modules/profiles/show/m/M.LoggedProfilePage'
import MPlacesListPage from '../../modules/places/list/m/M.PlacesListPage'
import MServiceOrdersListPage from '../../modules/serviceOrders/list/m/M.ServiceOrdersListPage'
import MUsersListPage from '../../modules/users/list/m/M.UsersListPage'
import MainRouterWrapper from './MainRouterWrapper'
import MapPage from '../../modules/map/main/MapPage'
import MinicrudsListPage from '../../modules/minicruds/list/MinicrudsListPage'
import ModalsRoutes from './modals/ModalsRoutes_'
import NewPasswordPage from '../../modules/session/newPassword/NewPasswordPage'
import NonComplianceListPageV2 from '../../modules/nonComplianceV2/list/NonCompliancesListPage'
import NotFoundPage from '../../modules/errors/404/NotFoundPage'
import OldRoutesRedirect from './OldRoutesRedirect'
import PlaceLevelsListPage from '../../modules/placeLevels/list/PlaceLevelsListPage'
import PlaceNonCompliancesListPage from '../../modules/nonComplianceV2/placeList/PlaceNonCompliancesListPage'
import PlacesListPage from '../../modules/places/list/PlacesListPage'
import PublicTemplate from '../../components/templates/PublicTemplate'
import RedirectWithParams from './RedirectWithParams'
import ResponsiveRender from '../../components/helpers/ResponsiveRender'
import ScanQrcodePage from '../../modules/qrcodes/scan/ScanQrcodePage'
import SegmentsListPage from '../../modules/segments/list/SegmentsListPage'
import ServiceOrderExecutionPage from '../../modules/serviceOrders/executionV2/ServiceOrderExecutionPage'
import ServiceOrderPdfPage from '../../modules/serviceOrders/pdf/ServiceOrderPdfPage'
import ServiceOrderResumeV2Page from '../../modules/serviceOrders/resumeV2/ServiceOrderResumePage'
import ServiceOrdersCalendarPage from '../../modules/serviceOrders/calendar/ServiceOrdersCalendarPage'
import ServiceOrdersKanbanPage from '../../modules/serviceOrders/kanban/ServiceOrdersKanbanPage'
import ServiceOrdersListPage from '../../modules/serviceOrders/list/ServiceOrdersListPage'
import ServiceOrdersRootPage from '../../modules/serviceOrders/root/ServiceOrdersRootPage'
import ShowQrcodePage from '../../modules/qrcodes/show/ShowQrcodePage'
import SuccessfullyExecutedFormPage from '../../modules/forms/sucessfullyExecuted/SuccessfullyExecutedFormPage'
import SuccessfullyExecutedServiceOrderPage from '../../modules/serviceOrders/sucessfullyExecuted/SuccessfullyExecutedServiceOrderPage'
import TemplateRaiaPdfPage from '../../modules/pdfs/segurpro/raia/TemplateRaiaPdfPage'
import TemplateRelatorioPdfPage from '../../modules/pdfs/srsms/relatorio/TemplateRelatorioPdfPage'
import TemplateSSOAcPage from '../../modules/pdfs/template-sso/ac/TemplateSSOAcPage'
import TemplateSSOAetPdfPage from '../../modules/pdfs/template-sso/aet/TemplateSSOAetPdfPage'
import TemplateSSOPgrPdfPage from '../../modules/pdfs/template-sso/pgr/TemplateSSOPgrPdfPage'
import TemplateSSOPgrTablePage from '../../modules/pdfs/template-sso/pgrTable/TemplateSSOPgrTablePage'
import TemplateVCIPdfPage from '../../modules/pdfs/vci/TemplateVCIPdfPage'
import TemplateSegurproVivoPdfPage from '../../modules/pdfs/segurpro/vivo/TemplateVivoPdfPage'
import TemplatePropostaManualPdfPage from '../../modules/pdfs/segurpro/proposta-manual/TemplatePropostaManualPdfPage'
import TriggerCallsListPage from '../../modules/triggerCalls/list/TriggerCallsListPage'
import TemplatePropostaPdfPage from '../../modules/pdfs/comercial/vivo/TemplatePropostaPdfPage'
import TemplateAllarmiPdfPage from '../../modules/pdfs/allarmi/TemplateAllarmiPdfPage'
import TemplateVivoPdfPage from '../../modules/pdfs/vivo/TemplateVivoPdfPage'
import UsersKanbanPage from '../../modules/users/kanban/UsersKanbanPage'
import UsersListPage from '../../modules/users/list/UsersListPage'
import UsersRootPage from '../../modules/users/root/UsersRootPage'
import IntegrationsListPage from '../../modules/integrations/list/IntegrationsListPage'
import IntegrationCheckInServicePage from '../../modules/integrations/checkIn/ServicePage'
import IntegrationMiddlewarePage from '../../modules/integrations/middleware/MiddlewarePage'
import TemplateTembiciPdfPage from '../../modules/pdfs/tembici/TemplateTembiciPdfPage'
import TemplateInternoPdfPage from '../../modules/pdfs/interno/TemplateInternoPdfPage'
import TemplateInternoPropostaSmbPdfPage from '../../modules/pdfs/interno/propostaSmb/TemplateInternoPropostaSmbPdfPage'
import TemplateCaramuruPdfPage from '../../modules/pdfs/caramuru/TemplateCaramuruPdfPage'
import MaskListPage from '../../modules/mask/list/MaskListPage'
import MServiceOrdersPublicListPage from '../../modules/serviceOrders/publicHistory/m/M.ServiceOrdersListPage'
import ServiceOrdersPublicHistoryModal from '../../modules/serviceOrders/publicHistory/ServiceOrdersPublicHistoryModal'
import WebhookListPage from '../../modules/webhook/list/WebhookListPage'
import FinancePage from '../../modules/finance/page/FinancePage'
import DynamicServiceOrdersListPage from '../../modules/dynamicServiceOrders/list/DynamicServiceOrdersListPage'
import DynamicServiceOrderExecutionPage from '../../modules/dynamicServiceOrders/execution/DynamicServiceOrderExecutionPage'
import SuccessfullyExecutedDynamicServiceOrderPage from '../../modules/dynamicServiceOrders/sucessfullyExecuted/SuccessfullyExecutedDynamicServiceOrderPage'
import TemplateInternoPropostaEnterprisePdfPage from '../../modules/pdfs/interno/propostaEnterprise/TemplateInternoPropostaEnterprisePdfPage'
import TemplateContratoPdfPage from '../../modules/pdfs/interno/contrato/TemplateContratoPdfPage'
import TemplateLopesDeFariaPdfPage from '../../modules/pdfs/lopesdefaria/TemplateLopesDeFariaPdfPage'
import TemplateBosiPdfPage from '../../modules/pdfs/bosi/TemplateBosiPdfPage'
import { GoogleLoginPage } from '../../modules/session/google/GoogleLoginPage'
import LoginFormInternal from '../../modules/session/login/LoginFormInternal'
import TemplateUniversalPdfPage from '../../modules/pdfs/universal/TemplateUniversalPdfPage'
import StocksListPage from '../../modules/stocks/list/StocksListPage'
import TemplateRelatorioMagnagoPdfPage from '../../modules/pdfs/magnago/relatorio/TemplateRelatorioPdfPage'
import TemplateLMDaSilvaPdfPage from '../../modules/pdfs/lmdasilva/TemplateLMDaSilvaPdfPage'
import TemplateSannyGoldPdfPage from '../../modules/pdfs/sannygold/TemplateSannyGoldPdfPage'
import TemplateInternoPropostaPdfPage from '../../modules/pdfs/interno/proposta/TemplateInternoPropostaPdfPage'
import TemplateMetaPdfPage from '../../modules/pdfs/meta/TemplateMetaPdfPage'
import TemplateItauPdfPage from '../../modules/pdfs/itau/TemplateItauPdfPage'
import TemplateManservPdfPage from '../../modules/pdfs/manserv/TemplateManservPdfPage'
import TemplateGrupoKallasPdfPage from '../../modules/pdfs/grupokallas/TemplateGrupoKallasPdfPage'
import TemplateConceptPdfPage from '../../modules/pdfs/concept/TemplateConceptPdfPage'
import TemplateEasySolutionsPdfPage from '../../modules/pdfs/easysolutions/TemplateEasySolutionsPdfPage'
import TemplateEpssoPdfPage from '../../modules/pdfs/epsso/TemplateEpssoPdfPage'
import ProcessesDashboardPage from '../../modules/processes/dashboard/ProcessesDashboardPage'
import ProcessesKanbanPage from '../../modules/processes/kanban/ProcessesKanbanPage'
import ProcessesPage from '../../modules/processes/ProcessesPage'
import ProcessesListPage from '../../modules/processes/list/ProcessesListPage'
import ProcessesRedirectWrapper from './ProcessesWrapper'
import TemplateInternoContratoV2PdfPage from '../../modules/pdfs/interno/contrato-v2/TemplateInternoContratoV2PdfPage'
import TemplateAxonPdfPage from '../../modules/pdfs/axon/TemplateAxonPdfPage'
import TemplateBiofixPdfPage from '../../modules/pdfs/biofix/TemplateBiofixPdfPage'

const Routes = () => {
  const canSeeDashboard = useSessionPermission('seeDashboard')

  return (
    <div className="pageWrapper">
      <MainRouterWrapper>
        <RedirectWithParams path="/m" to="/" />
        <OldRoutesRedirect path="/m/*" />
        <OldRoutesRedirect path="/v2/*" />
        <LoginFormInternal path="/internal" />
        <Redirect from="/auth/recovery-confirm" to="/public/auth/recovery-confirm" noThrow />
        <RedirectWithParams path="/forms/:shareCode/execution" to="/public/forms/:shareCode/execution" />
        <RedirectWithParams
          path="/dynamic-service-orders/:shareCode/execution"
          to="/public/dynamic-service-orders/:shareCode/execution"
        />
        <RedirectWithParams
          path="/forms/successfully-executed/:shareCode"
          to="/public/forms/successfully-executed/:shareCode"
        />
        <RedirectWithParams
          path="/dynamic-service-orders/successfully-executed/:shareCode"
          to="/public/dynamic-service-orders/successfully-executed/:shareCode"
        />

        <IntegrationMiddlewarePage path="middleware/integrations/:service/:workspace" />
        <IntegrationCheckInServicePage path="integrations/:service" />

        <ResponsiveRender Default={GoogleLoginPage} path="/login/internal" />

        <PublicTemplate path="/public" hideIntercom>
          <NewPasswordPage path="auth/recovery-confirm" />
          <FormExecutionPage path="forms/:shareCode/execution" />
          <SuccessfullyExecutedFormPage path="forms/successfully-executed/:shareCode" />
          <SuccessfullyExecutedServiceOrderPage path="service-orders/successfully-executed" />
          <SuccessfullyExecutedServiceOrderPage path="service-orders/successfully-executed" />

          <DynamicServiceOrderExecutionPage path="dynamic-service-orders/:shareCode/execution" />
          <SuccessfullyExecutedDynamicServiceOrderPage path="dynamic-service-orders/successfully-executed/:shareCode" />

          <FullMessagePage path="message" />

          <ResponsiveRender
            Sm={MServiceOrdersPublicListPage}
            Default={ServiceOrdersPublicHistoryModal}
            path="history/:token/:entityType/:entityId"
          />
        </PublicTemplate>

        <AuthTemplate path="/">
          <RedirectWithParams path="/login" to="/" />
          <RedirectWithParams path="/dashboard" to="/" />
          <RedirectWithParams path="/dashboard/home" to="/" />

          <ResponsiveRender
            Sm={MServiceOrdersListPage}
            Default={canSeeDashboard ? DashboardV2Page : ServiceOrdersListPage}
            path="/"
          />

          <ResponsiveRender Sm={MServiceOrdersListPage} Default={ServiceOrdersRootPage} path="service-orders" />
          <ResponsiveRender Sm={MServiceOrdersListPage} Default={ServiceOrdersListPage} path="service-orders/list" />
          <ResponsiveRender
            Sm={MServiceOrdersListPage}
            Default={ServiceOrdersCalendarPage}
            path="service-orders/calendar"
          />
          <ResponsiveRender
            Sm={MServiceOrdersListPage}
            Default={ServiceOrdersKanbanPage}
            path="service-orders/kanban/:id"
          />

          <HomePage path="home" />

          <ProcessesRedirectWrapper Default={ProcessesPage} path="processes" />
          <ProcessesRedirectWrapper Default={ProcessesKanbanPage} path="processes/kanban/:id" />
          <ProcessesRedirectWrapper Default={ProcessesDashboardPage} path="processes/dashboard/:id" />
          <ProcessesRedirectWrapper Default={ProcessesListPage} path="processes/list/:id" />

          <FinancePage path="finance" />

          <ServiceOrderResumeV2Page path="resume/:id" />
          <ServiceOrderResumeV2Page path="service-orders/resume/:id" />
          <ServiceOrderResumeV2Page path="service-orders/:id/resume" />
          <EditServiceOrderPage path="service-orders/new" />
          <ServiceOrderExecutionPage path="service-orders/:id/execution" />
          <ServiceOrderPdfPage path="service-orders/:id/pdf" />
          <RedirectWithParams path="/service-orders/create" to="/service-orders" />

          <ResponsiveRender Sm={MPlacesListPage} Default={PlacesListPage} path={`places/:type`} />

          <PlaceLevelsListPage path={`place-levels/:type`} />

          <DynamicServiceOrdersListPage path="dynamic-service-orders" />

          <FormsListPage path="forms" />
          <FormRepliesPage path="forms/:id/form-replies" />
          <FormReplyPage path="forms/:id/form-replies/:number" />
          <FormReplyPdfPage path="forms/:id/pdf/:number" />

          <ChecklistsListPage path="checklists" />
          <EditChecklistPage path="checklists/new" />
          <EditChecklistPage path="checklists/:id/edit" />

          <StocksListPage path="/stocks" />

          <ResponsiveRender Sm={MLoggedProfilePage} Default={LoggedProfilePage} path="profile" />

          <ResponsiveRender Sm={MAssetListPage} Default={AssetListPage} path="assets" />

          <MinicrudsListPage path="/minicruds/:entity" />

          <GroupsListPage path="/groups" />

          <ResponsiveRender Sm={MUsersListPage} Default={UsersRootPage} path="users" />
          <ResponsiveRender Sm={MUsersListPage} Default={UsersListPage} path="users/list" />
          <ResponsiveRender Sm={MUsersListPage} Default={UsersKanbanPage} path="users/kanban/:id" />
          <EditUserPage path="users/new" />

          <ImportPageV2 path="import/:entity" />
          <ImportPageV2 path="import/v2/:entity" />
          <MaskListPage path="masks" />

          <MapPage path="maps" />

          <SegmentsListPage path="/segmentations" />
          <EditSegmentPage path="segmentations/new" />
          <EditSegmentPage path="segmentations/:id/edit" />

          <RedirectWithParams path="/non-compliance" to="/non-compliances" />
          <RedirectWithParams path="/non-compliance/v2" to="/non-compliances" />
          <RedirectWithParams path="/non-compliances/v2" to="/non-compliances" />
          <NonComplianceListPageV2 path="/non-compliances" />
          <PlaceNonCompliancesListPage path="/place-non-compliances" />
          <AvailabilityPage path="/availability" />

          <BioqualynetAetPdfPage path="/pdfs/:templateId/portosaude/aet/:id" />
          <BioqualynetPgrPdfPage path="/pdfs/:templateId/portosaude/pgr/:id" />
          <BioqualynetAcPage path="/pdfs/:templateId/portosaude/ac/:id" />
          <BioqualynetPgrTablePage path="/pdfs/:templateId/portosaude/pgr-tabela/:id" />

          <BradescoPgrPdfPage path="/pdfs/:templateId/bradesco/pgr/:id" />

          <TemplateSSOAetPdfPage path="/pdfs/:templateId/template-sso/aet/:id" />
          <TemplateSSOPgrPdfPage path="/pdfs/:templateId/template-sso/pgr/:id" />
          <TemplateSSOAcPage path="/pdfs/:templateId/template-sso/ac/:id" />
          <TemplateSSOPgrTablePage path="/pdfs/:templateId/template-sso/pgr-tabela/:id" />

          <TemplateRaiaPdfPage path="/pdfs/:templateId/segurpronovo/raia/:id" />
          <TemplateSegurproVivoPdfPage path="/pdfs/:templateId/segurpronovo/vivo/:id" />
          <TemplatePropostaManualPdfPage path="/pdfs/:templateId/segurpronovo/proposta-manual/:id" />

          <TemplatePropostaPdfPage path="/pdfs/:templateId/comercial/proposta/:id" />
          <TemplateAllarmiPdfPage path="/pdfs/:templateId/allarmi/proposta/:id" />

          <TemplateVCIPdfPage path="/pdfs/:templateId/vcisa/hrh/:id" />
          <TemplateVCIPdfPage path="/pdfs/:templateId/vcisa/venture/:id" />
          <TemplateVCIPdfPage path="/pdfs/:templateId/vcisa/additive/:id" />

          <TemplateRelatorioPdfPage path="/pdfs/:templateId/srsms/relatorio/:id" />

          <TemplateRelatorioMagnagoPdfPage path="/pdfs/:templateId/magnago/relatorio/:id" />

          <TemplateVivoPdfPage path="/pdfs/:templateId/vivo/comparativo/:id" />

          <TemplateManservPdfPage path="/pdfs/:templateId/manserv/bm/:id" />

          <TemplateGrupoKallasPdfPage path="/pdfs/:templateId/grupokallas/auditoria/:id" />

          <TemplateConceptPdfPage path="/pdfs/:templateId/concept/contrato/:id" />

          <TemplateEasySolutionsPdfPage path="/pdfs/:templateId/easysolutions/manutencao-preventiva-fm200/:id" />
          <TemplateEasySolutionsPdfPage path="/pdfs/:templateId/easysolutions/manutencao-preventiva-sdai/:id" />
          <TemplateEasySolutionsPdfPage path="/pdfs/:templateId/easysolutions/manutencao-preventiva-co2-resinas/:id" />
          <TemplateEasySolutionsPdfPage path="/pdfs/:templateId/easysolutions/manutencao-preventiva-co2-lnp/:id" />
          <TemplateEasySolutionsPdfPage path="/pdfs/:templateId/easysolutions/relatorio-manutencao-sdai/:id" />

          <LogsListPage path="logs" />
          <TriggerCallsListPage path="trigger-calls" />

          <EditQrCodeTemplatePage path="/buckets/:id/pdf" />
          <EditTemplateContentPage path="/templates/:id/content" />

          <IntegrationsListPage path="/integrations" />
          <WebhookListPage path="/webhooks" />

          <TemplateTembiciPdfPage path="/pdfs/:templateId/tembici/desconto-folha/:id" />

          <TemplateInternoPdfPage path="/pdfs/:templateId/interno/rescisao/:id" />

          <TemplateInternoPropostaPdfPage path="/pdfs/:templateId/interno/proposta/:id" />
          <TemplateInternoContratoV2PdfPage path="/pdfs/:templateId/interno/contrato-v2/:id" />

          <TemplateInternoPropostaSmbPdfPage path="/pdfs/:templateId/interno/proposta-smb/:id" />
          <TemplateInternoPropostaEnterprisePdfPage path="/pdfs/:templateId/interno/proposta-enterprise/:id" />
          <TemplateContratoPdfPage path="/pdfs/:templateId/interno/contrato-proposta/:id" />

          <TemplateCaramuruPdfPage path="/pdfs/:templateId/caramuru/auditoria/:id" />

          <TemplateLopesDeFariaPdfPage path="/pdfs/:templateId/lopesdefaria/medicao-de-topografia/:id" />

          <TemplateUniversalPdfPage path="/pdfs/:templateId/universal/orcamento/:id" />

          <TemplateLMDaSilvaPdfPage path="/pdfs/:templateId/lmdasilva/resume/:id" />

          <TemplateBosiPdfPage path="/pdfs/:templateId/bosi/termo-de-uso/:id" />
          <TemplateBosiPdfPage path="/pdfs/:templateId/bosi/ordem-de-servico/:id" />
          <TemplateBosiPdfPage path="/pdfs/:templateId/bosi/certificado/:id" />

          <TemplateBiofixPdfPage path="/pdfs/:templateId/biofix/comunicado-tratamento/:id" />
          <TemplateBiofixPdfPage path="/pdfs/:templateId/biofix/guia-aplicacao/:id" variant="guide" />
          <TemplateBiofixPdfPage path="/pdfs/:templateId/biofix/notificacao-fumigacao/:id" variant="notice" />
          <TemplateBiofixPdfPage path="/pdfs/:templateId/biofix/carta-autorizacao/:id" variant="authorization" />
          <TemplateBiofixPdfPage path="/pdfs/:templateId/biofix/certificado-fumigacao/:id" variant="certificate" />
          <TemplateBiofixPdfPage path="/pdfs/:templateId/biofix/certificado-expurgo-exaustao/:id" variant="gasFree" />
          <TemplateBiofixPdfPage path="/pdfs/:templateId/biofix/relatorio-fotografico/:id" variant="photoReport" />

          <TemplateSannyGoldPdfPage path="/pdfs/:templateId/sannygold/proposta/:id" />

          <TemplateMetaPdfPage path="/pdfs/:templateId/meta/resume/:id" />

          <TemplateItauPdfPage path="/pdfs/:templateId/itau/resume/:id" />

          <TemplateEpssoPdfPage path="/pdfs/:templateId/epsso/avaliacao-ergonomica/:id" />

          <TemplateAxonPdfPage path="/pdfs/:templateId/axon/proposta-comercial/:id" />
          <TemplateAxonPdfPage path="/pdfs/:templateId/axon/bis/:id" />
          <TemplateAxonPdfPage path="/pdfs/:templateId/axon/cii/:id" />
          <TemplateAxonPdfPage path="/pdfs/:templateId/axon/proforma/:id" />
          <TemplateAxonPdfPage path="/pdfs/:templateId/axon/formulario/:id" />

          <NotFoundPage default />
        </AuthTemplate>
      </MainRouterWrapper>

      <Router basepath="/qrcodes" className="router">
        <RedirectWithParams path="/:id" to="/qrcodes/public/:id" />
        <RedirectWithParams path="/scan" to="/qrcodes/public/scan" />
        <RedirectWithParams path="/:id/scan" to="/qrcodes/public/:id/scan" />
        <PublicTemplate path="/public" hideIntercom>
          <ShowQrcodePage path=":id" />
          <ScanQrcodePage path="scan" />
          <ScanQrcodePage path=":id/scan" />
        </PublicTemplate>

        <AuthTemplate path="/">
          <ActivateQrcodePage path=":id/activate" />
        </AuthTemplate>
      </Router>

      <Router primary={false}>
        <ModalsRoutes default />
      </Router>
    </div>
  )
}

export default Routes
